/**
 * 上传图片模块，可以完成上传和剪切功能
 *
 * @author mingxin.huang
 * @update 2015.04.17
 */

$.module('MM.util.uploader', function () {
  // 0:用户头像  1:封面图片 3:家族头像 4:身份证正面 5:身份证反面 6:包厢封面 7:小窝封面,8:个人主页 9:小窝背景 10:直播间背景 11:手机直播封面图 12:用户分享链接二维码 13:运营修改主播封面
  var ACTIONS = {
    upload: MM.core.getRoot(
      'qiniu/upload_pic/{access_token}/{type}?room_id={room_id}',
      'api',
      'site',
    ), //上传接口
    // cutPic: 'user/cut_pic_new/{access_token}?url={url}&x={x}&y={y}&w={w}&h={h}&rw={rw}&rh={rh}&new={new}' //剪切接口
    cutPic:
      'qiniu/cut_pic/{access_token}?url={url}&x={x}&y={y}&w={w}&h={h}&rw={rw}&rh={rh}&new={new}', //剪切接口
  };

  /**
   * 额外需要的基础文件
   */
  var EXTRA_FILES = {
    upload: {
      //上传功能所需文件
      baseScripts: ['/ui/uploadify/jquery.uploadifive.js'],
    },
    crop: {
      //剪切功能所需文件
      baseStyles: ['/ui/Jcrop/jquery.Jcrop.css'],
      baseScripts: [
        '/ui/uploadify/jquery.uploadifive.js',
        '/ui/Jcrop/jquery.Jcrop.js',
      ],
    },
  };

  /**
   * 初始话上传功能
   * @param  {String} selector 上传点击区域的选择符
   * @param  {Number} type 上传类型
   * 0:用户头像  1:封面图片 3:家族头像 4:身份证正面 5:身份证反面
   * 6:包厢封面 7:小窝封面,8:个人主页 9:小窝背景 10 直播间背景
   * 11 手机直播间封面 12 用户分享二维码 13 照片墙
   * @param  {Object} opt 上传参数
   * {
   *     @param  {Number} width    宽度
   *     @param  {Number} height   高度
   *     @param  {String} text     按钮文字
   *     @param  {String} uploadScript   上传接口
   *     @param  {Function} success  上传成功的回调函数
   *     @param  {Function} error  上传失败的回调函数
   *     @param  {Object} formData  上传的时候同时携带的数据
   * }
   */

  var defaultOptions = {
    auto: true,
    removeCompleted: true,
    method: 'post',
    multi: true,
    fileObjName: 'file',
    buttonText: '上传',
    buttonClass: '',
    // queueSizeLimit: 2,
    fileType: 'image/*',
    fileSizeLimit: '5MB',
    overrideEvents: [
      'onError',
      'onDialogOpen',
      'onDialogClose',
      'onSelect',
      'onProgress',
      'addQueueItem',
    ],
    onFallback: function () {
      MM.ui.messager.warn('浏览器不支持HTML5,无法上传！');
    },
    onSelect: function () {},
    onProgress: function (file, e) {
      if (e.lengthComputable) {
        var percent = Math.round((e.loaded / e.total) * 100);
        var name = file.name;
        if (name.len > 6) {
          name = name.substring(0, 5) + '..';
        }
        $('#j_progress_val').text(name + '-' + percent + '%');
      }
    },
    onQueueComplete: function () {
      $('#j_progress_val').text('');
    },
    onError: function (errorType, file) {
      if (file != 0) {
        var msg = '上传失败请重试';
        switch (errorType) {
          case 'UPLOAD_LIMIT_EXCEEDED':
            msg = '上传的文件数量[' + file.name + ']已超出！';
            break;
          case 'FILE_SIZE_LIMIT_EXCEEDED':
            msg = '文件 [' + file.name + '] 大小超出系统限制';
            break;
          case 'QUEUE_LIMIT_EXCEEDED':
            msg = '任务数量超出队列限制';
            break;
          case 'FORBIDDEN_FILE_TYPE':
            msg = '文件 [' + file.name + '] 类型不正确！';
            break;
          case '404_FILE_NOT_FOUND':
            msg = '文件未上传成功或服务器存放文件的文件夹不存在';
            break;
        }
        MM.core.debug('onError', msg);
        MM.ui.messager.warn(msg);
      }
    },
  };

  function _initUpload(selector, opt) {
    // 判断是否已经有加载过基础模块
    if (!$.fn.uploadifive) {
      MM.ui.messager.loading();

      MM.core.loadScriptCss(EXTRA_FILES.upload, function () {
        MM.ui.messager.close();

        return _initUpload(selector, opt);
      });
      return;
    }

    var $upload = selector instanceof $ ? selector : $(selector);
    var defaultUploader = $.formatByVal(ACTIONS.upload, {
      access_token: MM.user.getToken(),
      type: opt.type,
      room_id:
        (_.get(MM, 'live.room.getRoomId') && MM.live.room.getRoomId()) ||
        _cropOpt.room_id,
    });

    var uploadOptions = _.assignWith(
      {},
      defaultOptions,
      {
        uploadScript: defaultUploader,
        onUploadComplete: function (file, data, res) {
          if ($.isFunction(opt.success)) {
            data = $.parseJSON(data);

            if (data.code == 1 || data.code == 200) {
              opt.success(file, data, res);
            } else {
              var msg = {
                30431: '图片涉及敏感信息，上传失败',
              };

              MM.ui.messager.warn(
                msg[data.code] ||
                  '很抱歉，上传出现异常。[code:' + data.code + ']',
              );
            }
          }
        },
      },
      _.omit(opt, ['onUploadSuccess']),
    );

    if (opt.type) {
      uploadOptions.formData = _.assign(uploadOptions.formData, {
        type: opt.type,
      });
    }
    uploadOptions.uploadScript = uploadOptions.uploadScript || defaultUploader;

    // MM.core.debug("upload options : ", uploadOptions, opt);

    $upload.uploadifive(uploadOptions);

    return $upload;
  }

  // 剪切功能默认参数
  var _cropOpt = {
    title: '上传图片', //弹出框title
    remark: '', //弹出框备注
    pw: 200, //缩略图宽
    ph: 200, //缩略图高
    type: 0, //上传类型
    pic_url: MM.config.defultCover, //默认显示图片
    minSize: null, //图片最小宽高尺寸[w, h]
    selectSize: null, //设置剪切区域的高宽[w, h]
    outputSize: null, //生成图片的高宽[w, h]
    success: null, //剪切成功后的回调,返回的图片地址
    formData: null,
    selectError: null,
    uploadError: null,
    uploadType: 0, //0 img.sumeme 1 upyun
    // picType: 0, //
  };

  /**
   * 显示带剪切功能的上传
   * @param  {[type]} opt [description]
   * @return {[type]}     [description]
   */
  function _showCrop(opt) {
    // 判断是否已经有加载过基础模块
    if (!$.fn.Jcrop) {
      MM.ui.messager.loading();

      MM.core.loadScriptCss(EXTRA_FILES.crop, function () {
        MM.ui.messager.close();

        _showCrop(opt);
      });
      return;
    }

    _cropOpt = _.assign({}, _cropOpt, opt);

    MM.core.debug('uploader _cropOpt', _cropOpt);

    _showCropPopup();
  }

  var _tmplBody =
      '\
        <div class="ui-uploader fix">\
            <div class="ui-uploader-left">\
                <img src="" alt="" class="ui-uploader-pic" id="j_upload_pic" />\
            </div>\
            <div class="ui-uploader-right">\
                <p style="padding-top:0;">图片预览：</p>\
                <div class="ui-uploader-preview">\
                    <div class="ui-uploader-preview-bg" >\
                    <img src="" alt="" id="j_upload_preview" />\
                    </div>\
                </div>\
                <div class="btn-area">\
                    <a href="javascript:;" class="btn-warn" id="j_upload_select">上传图片</a>\
                </div>\
                <p><%=remark%></p>\
                <p id="j_upload_MM.core.debug"></p>\
                <div  style="display: none">\
                <button id="test" class="btn btn-primary">横</button>\
                <button id="test2" class="btn btn-primary">竖</button>\
                <button id="test3" class="btn btn-primary">方形</button>\
                </div>\
                <div id="j_progress_val"></div>\
            </div>\
        </div>\
        ',
    _tmplFooter =
      '\
            <a href="javascript:;" class="btn btn-round btn-solid-success" id="j_upload_save">确定</a>&nbsp;\
            <a href="javascript:;" class="btn btn-round btn-default popup-close" id="j_upload_cancel">取消</a>\
        ';

  var $uploadPic = null,
    $previewPic = null;

  /**
   * 显示弹窗
   */
  function _showCropPopup() {
    var fn = function () {
      $uploadPic = $('#j_upload_pic')
        .attr('src', _cropOpt.pic_url)
        .removeAttr('style');
      $previewPic = $('#j_upload_preview').attr('src', _cropOpt.pic_url);
      $previewPic.parent().css({
        width: _cropOpt.pw,
        height: _cropOpt.ph,
      });
      _currPic = _cropOpt.pic_url;
      // _initJcrop()

      // if (_cropOpt.picType) {
      //   $('#j_upload_pic_type').val(_cropOpt.picType);
      // }

      var uploadOpt = {
        buttonClass: 'btn-solid-success btn btn-round',
        width: 210,
        height: 30,
        uploader: _cropOpt.uploader,
        formData: _cropOpt.formData || {
          access_token: MM.user.getToken(),
        },
        success: _handleCropUploaded,
        type: _cropOpt.type,
        fileSizeLimit: '3MB',
      };
      _initUpload('#j_upload_select', uploadOpt);
      _registerEvents();
    };
    var onBeforeClose = function () {
      //IE 中 bug  删除弹窗 要先手动销毁上传组件
      try {
        $('#j_upload_select').uploadifive('destroy');
      } catch (e) {}
    };

    var popupOpt = {
      id: 'j_ui_uploader',
      classes: 'ui-uploader-popup',
      width: 660,
      center: true,
      force: true,
      disableMsk: true,
      title: _cropOpt.title,
      content: $.template(_tmplBody, {
        remark: _cropOpt.remark,
        // picType: _cropOpt.picType,
      }),
      footer: _tmplFooter,
      appendCallback: fn,
      onBeforeClose: onBeforeClose,
    };

    MM.ui.popup.show(popupOpt);
  }

  /**
   * 监听弹出框按钮事件
   */
  function _registerEvents() {
    $('#j_upload_save').click(function () {
      // if (!MM.user.isCompleteMobileBind() && !MM.user.isMobileBind()) {
      //     return MM.user.showBindMobilePopup()
      // }
      // 图片未改变
      if (!_currPic || _currPic == _cropOpt.pic_url) {
        return MM.ui.popup.hide();
      }

      _cutData.url = _currPic;
      _cutData.x = Math.round(_cutData.x / _originRatio);
      _cutData.y = Math.round(_cutData.y / _originRatio);
      _cutData.w = Math.round(_cutData.w / _originRatio);
      _cutData.h = Math.round(_cutData.h / _originRatio);

      // 设置最终生成的图片尺寸
      if (_cropOpt.outputSize) {
        _cutData.rw = _cropOpt.outputSize[0];
        _cutData.rh = _cropOpt.outputSize[1];
      }

      //type  区别接口
      if (_cropOpt.uploadType) {
        if ($.isFunction(_cropOpt.success)) {
          MM.ui.popup.hide();
          _cropOpt.success(_cutData, '1');
        }
      } else {
        MM.core.getResult({
          url: ACTIONS.cutPic,
          requireToken: true,
          data: _cutData,
          success: function (res) {
            MM.ui.popup.hide();
            if ($.isFunction(_cropOpt.success)) {
              _cropOpt.success(res.data.pic_url, '1');
            }
          },
        });
      }
    });

    $('#test').click(function () {
      _currPic =
        'https://test-img-photo.sumeme.com/38/6/20854246_null.jpg?v=1584083191450';
      if (_jCropControl) {
        _jCropControl.destroy();
      }
      _initJcrop();
    });
    $('#test2').click(function () {
      _currPic =
        'https://test-img-photo.sumeme.com/38/6/20854246_null.jpg?v=1584105816305';
      if (_jCropControl) {
        _jCropControl.destroy();
      }
      _initJcrop();
    });
    $('#test3').click(function () {
      _currPic =
        'https://test-img-photo.sumeme.com/27/3/20088731_null.jpeg?v=1584078532025';
      if (_jCropControl) {
        _jCropControl.destroy();
      }
      _initJcrop();
    });
  }

  var _jCropControl = null,
    _currPic = null,
    _originW = 0, //初始宽度
    _originH = 0, //初始高度
    _cutRatio = 0,
    _originRatio = 0; //初始图片和剪切区域比例

  /**
   * 处理文件上传成功回调
   * @param  {[type]} file [description]
   * @param  {[type]} data [description]
   * @param  {[type]} res  [description]
   * @return {[type]}      [description]
   */
  function _handleCropUploaded(file, data, res) {
    if (data.code != 1 && data.code != 200) {
      return;
    }

    if (_jCropControl) {
      _jCropControl.destroy();
    }

    _currPic = data.data.pic_url;

    _initJcrop(_currPic, true);
  }

  /**
   * 初始化剪切功能
   */
  function _initJcrop() {
    var image = new Image();

    image.onload = function () {
      _originW = image.width;
      _originH = image.height;

      MM.core.debug('uploader _originW,_originH', _originW, _originH, _currPic);
      // 判断是否小于最小尺寸
      if (_cropOpt.minSize) {
        if (_originW < _cropOpt.minSize[0] || _originH < _cropOpt.minSize[1]) {
          // MM.ui.popup.hide();
          _currPic = '';
          MM.ui.messager.warn(
            '图片尺寸过小，请重新上传。[' +
              _cropOpt.minSize[0] +
              'x' +
              _cropOpt.minSize[1] +
              ']',
          );
          return;
        }
      }

      var bw = 0,
        bh = 0;
      var ex = 0,
        ey = 0;
      if (_originW / _originH > _cropOpt.pw / _cropOpt.ph) {
        bw = _originW > 350 ? 350 : _originW;
        bh = (_originH * bw) / _originW;
        ey = bh;
        ex = (_cropOpt.pw / _cropOpt.ph) * ey;
        _originRatio = bw / _originW;
        _cutRatio = ey / _originH;
        MM.core.debug('upload init Jcrop 11', bw, bh, _originRatio, ex, ey);
      } else {
        bh = _originH > 350 ? 350 : _originH;
        bw = (_originW * bh) / _originH;
        _originRatio = bh / _originH;
        ex = bw;
        ey = (_cropOpt.ph / _cropOpt.pw) * ex;
        _cutRatio = ex / _originW;
        MM.core.debug('upload init Jcrop 22', bw, bh, _originRatio, ex, ey);
      }

      $uploadPic = $('#j_upload_pic')
        .attr('src', _currPic)
        .css({
          width: bw + 'px',
          height: bh + 'px',
        });
      $previewPic = $('#j_upload_preview');
      $previewPic.parent().css({
        width: _cropOpt.pw,
        height: _cropOpt.ph,
      });

      var cropOpt = {
        onChange: _showPreview,
        onSelect: _showPreview,
        aspectRatio: _cropOpt.pw / _cropOpt.ph,
        allowSelect: false,
        bgColor: '',
        boxWidth: bw,
        boxHeight: bh,
      };

      // 设置选择区域大小
      if (_cropOpt.selectSize) {
        cropOpt.minSize = [
          _cropOpt.selectSize[0] * _originRatio,
          _cropOpt.selectSize[1] * _originRatio,
        ];
      }

      MM.core.debug('uploader cropOpt', cropOpt);
      $uploadPic.Jcrop(cropOpt, function () {
        _jCropControl = this;

        _jCropControl.setSelect([0, 0, ex, ey]);
      });
    };

    image.src = _currPic;
  }

  var _cutData = {};

  /**
   * 显示预览图
   * @param  {Object} coords 坐标数据
   */
  function _showPreview(coords) {
    MM.core.debug('upload _showPreview', coords);

    var ratio = 1;

    if (_originW / _originH > _cropOpt.pw / _cropOpt.ph) {
      ratio = _cropOpt.ph / coords.h;
    } else {
      ratio = _cropOpt.pw / coords.w;
    }

    _cutData = $.extend(
      {
        rw: _cropOpt.pw,
        rh: _cropOpt.ph,
      },
      coords,
    );
    MM.core.debug('upload ratio', ratio, _originW, _originRatio);
    $previewPic.attr('src', _currPic).css({
      // width: Math.round(ratio * _originW * _originRatio) + 'px',
      // height: Math.round(ratio * _originH * _originRatio) + 'px',
      width: _originW * ratio * _originRatio + 'px',
      height: _originH * ratio * _originRatio + 'px',
      marginLeft: '-' + Math.round(ratio * coords.x) + 'px',
      marginTop: '-' + Math.round(ratio * coords.y) + 'px',
    });
  }

  return {
    initUpload: _initUpload,
    showCrop: _showCrop,
  };
});
